// @flow
import { handleResponseOld, makePost } from './helpers';

type FetchCatalogDetailsByIdsParams = {
    catalogIds: any,
    deployment: string,
};

export default {
    fetchCatalogDetailsByIds: ({ catalogIds, deployment }: FetchCatalogDetailsByIdsParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makePost({ deployment, path: '<ITEM-API>spa/small/catalog-detail' });
            request.send({ ids: catalogIds });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
